import i18n from "../i18n.js";

const profileMenuItems = [
  {
    name: i18n.t("Security"),
    testID: "navbar-security",
    icon: "info-circle",
    exact: true,
    link: "/profile/security",
  },
];

const systemMenuItems = [
  {
    name: "Overview",
    testID: "navbar-overview",
    icon: "info-circle",
    exact: true,
    link: "/system/overview",
  },
  {
    name: i18n.t("Settings"),
    testID: "navbar-settings",
    icon: "gear",
    link: "/system/global_settings",
    subnav: [
      {
        name: i18n.t("Administrators"),
        testID: "navbar-administrators",
        link: "/system/global_settings/administrators",
      },
      {
        name: i18n.t("Global Block Page"),
        testID: "navbar-global-block-page",
        link: "/system/global_settings/global_block_page",
      },
      {
        name: i18n.t("Global Default Policy"),
        testID: "navbar-global-default-policy",
        link: "/system/global_settings/global_default_policy",
      },
      {
        name: i18n.t("Global Domains"),
        testID: "navbar-global-domains",
        link: "/system/global_settings/global_domains",
      },
      {
        name: i18n.t("Tools"),
        testID: "navbar-tools",
        link: "/system/global_settings/tools",
        disabled: false,
      },
      {
        name: i18n.t("Certificates"),
        testID: "navbar-certificates",
        link: "/system/global_settings/certificates",
      },
      {
        name: i18n.t("Support"),
        testID: "navbar-support",
        link: "/system/global_settings/support",
      },
      {
        name: i18n.t("Email Settings"),
        testID: "email-settings",
        link: "/system/global_settings/email_settings",
      },
    ],
  },
];

const salesMenuItems = [
  {
    name: "Overview",
    testID: "navbar-overview",
    icon: "info-circle",
    exact: true,
    link: "/sales/msps",
  },
];

const mspMenuItems = [
  {
    name: "Overview",
    testID: "navbar-overview",
    icon: "info-circle",
    exact: true,
    link: "/msp/overview",
  },
  {
    name: i18n.t("Settings"),
    testID: "navbar-settings",
    icon: "gear",
    link: "/msp/global_settings",
    subnav: [
      {
        name: i18n.t("Administrators"),
        testID: "navbar-administrators",
        link: "/msp/global_settings/administrators",
      },
      {
        name: i18n.t("Security Settings"),
        testID: "navbar-security-settings",
        link: "/msp/global_settings/security_settings",
      },
      {
        name: i18n.t("Interface"),
        testID: "navbar-interface",
        link: "/msp/global_settings/interface",
      },
      {
        name: i18n.t("Global Block Page"),
        testID: "navbar-global-block-page",
        link: "/msp/global_settings/global_block_page",
      },
      {
        name: i18n.t("Global Default Policy"),
        testID: "navbar-global-default-policy",
        link: "/msp/global_settings/global_default_policy",
      },
      {
        name: i18n.t("Global Domains"),
        testID: "navbar-global-domains",
        link: "/msp/global_settings/global_domains",
      },
      {
        name: i18n.t("Tools"),
        testID: "navbar-tools",
        link: "/msp/global_settings/tools",
        disabled: false,
      },
      {
        name: i18n.t("Certificates"),
        testID: "navbar-certificates",
        link: "/msp/global_settings/certificates",
      },
      {
        name: i18n.t("Support"),
        testID: "navbar-support",
        link: "/msp/global_settings/support",
      },
      {
        name: i18n.t("Email Settings"),
        testID: "email-settings",
        link: "/msp/global_settings/email_settings",
      },
    ],
  },
];

const customerMenuItems = [
  {
    name: i18n.t("Overview"),
    testID: "navbar-dashboard",
    icon: "info-circle",
    exact: true,
    link: "/customer/overview",
  },
  {
    name: i18n.t("Recent Traffic"),
    testID: "navbar-recent-traffic",
    icon: "clock",
    link: "/customer/recent_traffic",
  },
  {
    name: i18n.t("Content Filtering"),
    testID: "navbar-content-filtering",
    icon: "shield",
    link: "/customer/content_filtering",
    subnav: [
      {
        name: i18n.t("Policies"),
        testID: "navbar-policies",
        link: "/customer/content_filtering/policies",
      },
      {
        name: i18n.t("Domains"),
        testID: "navbar-domains",
        link: "/customer/content_filtering/domains",
      },
      {
        name: i18n.t("Block Page"),
        testID: "navbar-block-page",
        link: "/customer/content_filtering/block_page",
      },
    ],
  },
  {
    name: i18n.t("Environment"),
    testID: "navbar-environment",
    icon: "geo-alt",
    link: "/customer/environment",
    subnav: [
      {
        name: i18n.t("Locations"),
        testID: "navbar-locations",
        link: "/customer/environment/locations",
      },
      {
        name: i18n.t("Devices"),
        testID: "navbar-devices",
        link: "/customer/environment/devices",
      },
      {
        name: i18n.t("Groups"),
        testID: "navbar-goups",
        link: "/customer/environment/groups",
      },
      {
        name: i18n.t("Users"),
        testID: "navbar-users",
        link: "/customer/environment/users",
      },
    ],
  },
  {
    name: i18n.t("Reporting"),
    testID: "navbar-reporting",
    icon: "file-bar-graph",
    link: "/customer/reporting",
    subnav: [
      {
        name: i18n.t("Summary "),
        testID: "navbar-reports-summary",
        link: "/customer/reporting/summary",
        disabled: false,
      },
      {
        name: i18n.t("Behavior Reports"),
        testID: "navbar-reports",
        link: "/customer/reporting/behavior_reports",
        disabled: false,
      },
      {
        name: i18n.t("Blocked Reports"),
        testID: "navbar-reports",
        link: "/customer/reporting/blocked_reports",
        disabled: false,
      },
      {
        name: i18n.t("Security Reports"),
        testID: "navbar-reports",
        link: "/customer/reporting/security_reports",
        disabled: false,
      },
      {
        name: i18n.t("Trend Reports"),
        testID: "navbar-reports",
        link: "/customer/reporting/trend_reports",
        disabled: false,
      },
      {
        name: i18n.t("History Reports"),
        testID: "navbar-reports",
        link: "/customer/reporting/history_reports",
        disabled: false,
      },
    ],
  },
  {
    name: i18n.t("Settings"),
    testID: "navbar-settings",
    icon: "gear",
    link: "/customer/settings",
    subnav: [
      {
        name: i18n.t("Administrators"),
        testID: "navbar-administrators",
        link: "/customer/settings/administrators",
      },
      {
        name: i18n.t("Default Policy"),
        testID: "navbar-default-policy",
        link: "/customer/settings/default_policy/",
      },
      {
        name: i18n.t("Tools"),
        testID: "navbar-tools",
        link: "/customer/settings/tools",
        disabled: false,
      },
      {
        name: i18n.t("Certificates"),
        testID: "navbar-certificates",
        link: "/customer/settings/certificates",
      },
      {
        name: i18n.t("Device Exceptions"),
        testID: "navbar-certificates",
        link: "/customer/settings/device_exceptions",
      },
      {
        name: i18n.t("Device Configuration"),
        testID: "navbar-device-configuration",
        link: "/customer/settings/device_configuration",
      },
    ],
  },
];

export default {
  install(Vue) {
    Vue.prototype.$getPrimaryNavItems = (type) => {
      switch (type) {
        case "profile":
          return profileMenuItems;
        case "system":
          return systemMenuItems;
        case "sales":
          return salesMenuItems;
        case "msp":
          return mspMenuItems;
        case "customer":
          return customerMenuItems;
        default:
          return customerMenuItems;
      }
    };
  },
};
